import type { ReactNode } from 'react';
import { classes } from '../../../utils/classes';

export const PromotionStyleWrapper = ({
  children,
  darkStyle,
  isPayback,
}: {
  children: ReactNode;
  darkStyle: boolean;
  isPayback: boolean;
}) => (
  <div
    className={classes(
      isPayback
        ? 'bg-color-payback text-color-text-light'
        : 'bg-color-primary text-color-primary-contrasttext',
      'flex min-h-[4.5rem] flex-col justify-center text-center lg:min-h-6',
      darkStyle && 'rounded-tl-[1.875rem] rounded-br-[1.875rem] text-left',
    )}
  >
    {children}
  </div>
);
